import * as ko from "knockout";
import entityBase from 'entityBase';

export class part_need extends entityBase {

    part_line_code: KnockoutObservable<string>;
    part_id: KnockoutObservable<string>;
    description: KnockoutObservable<string>;
    place_id_from: KnockoutObservable<string>;
    quantity: KnockoutObservable<number>;
    location_from: KnockoutObservable<string>;
    promised_dt: KnockoutObservable<string>;
    parts_used: KnockoutObservable<string>;

    constructor(item: any) {
        super();

        this.part_line_code = ko.observable(item.part_line_code);
        this.part_id = ko.observable(item.part_id);
        if (item.part) {
            this.description = ko.observable(item.part.internal_descriptn);
        } else this.description = ko.observable();
        this.place_id_from = ko.observable(item.place_id_from);
        this.quantity = ko.observable(item.quantity);
        this.location_from = ko.observable(item.location_from);
        this.promised_dt = ko.observable(item.promised_dt);
        this.parts_used = ko.observable(item.parts_used);
    }
}


